module.exports = __webpack_public_path__ + "img/logo.eb1f266f.png";